"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transfers = void 0;
const client_1 = require("@arkecosystem/client");
class Transfers extends client_1.Resource {
    async all(query) {
        return this.sendGet("nft/transfers");
    }
    async get(id) {
        return this.sendGet(`nft/transfers/${id}`);
    }
}
exports.Transfers = Transfers;
//# sourceMappingURL=transfers.js.map